import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import { Button, AutoComplete, Select } from '..';
import styles from './styles.module.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {Row, Col} from 'react-flexbox-grid';
import { Title } from '../../components';
import { useWindowSize, ResponsiveSize } from '../../utils/useWindowSize';

const SearchFormLeft = () => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [focusedInput, setFocusedInput] = useState();
  const setDates = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const adults = ["1 Adults","2 Adults","3 Adults","4 Adults"];
  const children = ["1 Children","2 Children","3 Children","4 Children"];
  const rooms = ["1 Room","2 Room","3 Room","4 Room"];
  return (
    <div className={styles.leftSearchBar}>
      <FormWrapper >
        <Title medium bold text={'Destination'} bottomLine/>
        <AutoComplete placeholder={'City Or Specific Hotels'}/>
      </FormWrapper>
      <FormWrapper>
        <Title medium bold text={'Check In Check Out'} bottomLine/>
        <DateRangePicker
          verticalHeight={370}
          numberOfMonths={useWindowSize().width <= ResponsiveSize.MD ? 1:2}
          showDefaultInputIcon
          startDatePlaceholderText={'Check In'}
          endDatePlaceholderText={'Check Out'}
          startDateId={'startDate'}
          endDateId={'endDate'}
          startDate={startDate}
          endDate={endDate}
          onDatesChange={({ startDate, endDate }) => {
            setDates(startDate, endDate);
          }}
          focusedInput={focusedInput}
          onFocusChange={(focusedInput) => {
            setFocusedInput(focusedInput);
          }}
        />
      </FormWrapper>
      <FormWrapper>
        <Title medium bold text={'ROOM & Guests'} bottomLine/>
        <Select placeholder={"Select Adults"} name={"adults"} data={adults} />
      </FormWrapper>
      <Row>
        <Col lg={6} sm={12} xs={12}>
          <Select placeholder={"No Children"} name={"names"} data={children} />

        </Col>
        <Col lg={6} sm={12} xs={12}>
          <Select placeholder={"Select Adults"} name={"rooms"} data={rooms} />
        </Col>
      </Row>
      <div className={styles.searchButton}>
        <Button onClick={() => alert('search')}>{'Search'}</Button>
      </div>
    </div>
  );
};
const FormWrapper = ({ children }) => <div className={styles.formWrapper}>{children}</div>;

export default SearchFormLeft;
